.footer {
  flex: 0 0 auto;
  padding: 0.75rem 0;
  border-top: 1px solid $white-10;
}

.header {
  padding: 0 1.25rem 0.25rem;
  color: $gray-700;
}

.interfaces {
  padding: 0.25rem 1.25rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.interface {
  min-width: 0;
  max-width: 100%;

  > div {
    max-width: 100%;

    > button:first-child {
      min-width: 0;
      max-width: calc(100% - 1.5rem);
      justify-content: flex-start;
      padding-inline: 0.5rem;
    }
  }
}

.interfaceCopy {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
}

.address {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goIcon {
  flex: 0 0 auto;
  @include rotate-fourty-five;
  margin-left: 0.25rem;
  margin-bottom: 0.25rem;
}
